import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BestOddsGuaranteeBadgeComponent } from '@frontend/sports/bog-help/feature';
import { PriceboostCountSignpostComponent } from '@frontend/sports/price-boost/feature';

import PickOddsComponent from './components/digital/pick-odds.component';

@NgModule({
    imports: [CommonModule, PriceboostCountSignpostComponent, BestOddsGuaranteeBadgeComponent],
    declarations: [PickOddsComponent],
    exports: [PickOddsComponent],
})
export default class PickOddsModule {}
